<script setup>
import { defineProps, ref, computed } from "vue";

const props = defineProps({
	title: {
		type: String,
		default: "",
	},
	buttonUrl: {
		type: String,
		default: "",
	},
	postId: {
		type: Number,
		default: 0,
	},
	labels: {
		type: Object,
	},
	hideSupporters: {
		type: Boolean,
	},
	buttonColor: {
		type: String,
		default: "orange",
	},
});

const progressData = ref({});
const isLoaded = ref(false);
fetch(
	window.WPURLS.ajaxurl +
		"?" +
		new URLSearchParams({
			action: "crowdfunding_progress",
			post_id: props.postId,
		})
)
	.then((response) => {
		return response.json();
	})
	.then((data) => {
		isLoaded.value = true;
		progressData.value = data.data;
	});

const goalPercentage = computed(() => {
	return progressData.value?.goalPercentage;
});
</script>

<template>
	<div class="c-crowdfunding" v-if="isLoaded">
		<h2 class="c-crowdfunding__title" v-if="props.title">{{ props.title }}</h2>
		<div class="c-crowdfunding__numbers">
			<span class="c-crowdfunding-progressnumber">{{ progressData.currentAchievedAmount }}</span>
			<span class="c-crowdfunding-goal">Doel: {{ progressData.endGoal }}</span>
		</div>
		<div class="c-crowdfunding-progress">
			<div
				class="c-crowdfunding-progress__bar"
				:style="{ width: Math.min(100, goalPercentage) + '%' }"
				:class="goalPercentage > 90 ? 'c-crowdfunding-progress__bar--shift' : ''"
			>
				<span class="c-crowdfunding-progress__text">{{ goalPercentage }}%</span>
			</div>
		</div>
		<div class="c-crowdfunding__data">
			<span class="c-crowdfunding__data--achieved">{{ progressData.converted }}</span>
			<span class="c-crowdfunding__data--days">{{ progressData.timeLeft }}</span>
		</div>

		<a
			v-bind:data-attribute="props.buttonUrl.includes('#') ? 'data-scroll' : ''"
			:href="props.buttonUrl"
			class="buttonn button--uppercase gform_button button--full-width"
			:class="'button--' + buttonColor"
			v-if="!progressData.actionFinished && props.buttonUrl"
		>
			<span>{{ props.labels.buttonLabel }}</span>
		</a>

		<div class="c-crowdfunding__finished" v-if="progressData.actionFinished">
			<div class="buttonn gform_button button--grey button--full-width">
				<span>{{ props.labels.finishedLabel }}</span>
			</div>
			<a href="/doneren" class="buttonn button--uppercase gform_button button--orange button--full-width">
				<span>{{ props.labels.otherDonationLabel }}</span>
			</a>
		</div>

		<div class="c-crowdfunding-supporters" v-if="!hideSupporters && progressData.supporters">
			<div class="gsection"></div>
			<h2 class="c-crowdfunding-supporters__title">Zij hielpen al mee:</h2>
			<ul class="c-crowdfunding-supporters__list">
				<li v-for="supporter in progressData.supporters">
					<div class="c-crowdfunding-supporters__data">
						<span class="c-crowdfunding-supporters__date">{{ supporter.date }}</span>
						<span class="c-crowdfunding-supporters__name">{{ supporter.name }}</span>
					</div>
					<span class="c-crowdfunding-supporters__amount">{{ supporter.amount }}</span>
				</li>
			</ul>
			<div
				class="c-crowdfunding-supporters__extra"
				v-if="progressData.extraSupporterCount !== null"
				v-html="progressData.extraSupporterCount"
			></div>
		</div>
	</div>
</template>
